module.exports = __webpack_public_path__ + "static/media/Empty_State_Matrix.b2472941.png";